import { installmentActions } from '../ActionTypes';
import { updateState } from '../../middlewares/utils';

const initialFormData = {
  Id: '0',
  Title: '',
  Terms: '',
  Interval: '',
  AdditionalDays: '',
  FinePercentage: '',
  InterestRate: ''
};

const defaultState = {
  installmentList: [],
  tableLoading: false,
  form: initialFormData,
  formLoading: false,
  formError: null,
  deleteId: null
};


export default (state = defaultState, actions) => {
  switch (actions.type) {
    case installmentActions.INSTALLMENT_FETCH_START:
      return updateState(state, { tableLoading: true });
    case installmentActions.INSTALLMENT_FETCH_SUCCESS:
      return updateState(state, { tableLoading: false, installmentList: actions.payload });
    case installmentActions.INSTALLMENT_FETCH_ERROR:
      return updateState(state, { tableLoading: false, ...actions.payload });
    case installmentActions.INSTALLMENT_SAVE_START:
      return updateState(state, { formLoading: true, formError: null, form: initialFormData });
    case installmentActions.INSTALLMENT_SAVE_SUCCESS:
      return updateState(state, { formLoading: false, form: initialFormData });
    case installmentActions.INSTALLMENT_SAVE_FAILED:
      return updateState(state, { formLoading: false, ...actions.payload });
    case installmentActions.INSTALLMENT_SET_FORM:
      return updateState(state, { ...actions.payload, formError: null });
    case installmentActions.INSTALLMENT_RESET_FORM:
      return updateState(state, { form: initialFormData });
    default:
      return state;
  }
};
